/* eslint-disable no-plusplus */
/* eslint prefer-regex-literals: "error" */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable no-useless-escape */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-destructuring */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */

import React, { ReactNode } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import {
  FilePdfOutlined,
  FileExcelOutlined,
  FileWordOutlined,
  FileImageOutlined,
  FileTextOutlined,
  FileZipOutlined,
  FileUnknownOutlined} from "@ant-design/icons";

import type { UploadFile } from "antd/es/upload/interface";
import { SorterResult } from "antd/es/table/interface";

import { isUserCeo } from "../../Services/Permissions";

import textResource from "../../Resources/Languages/Language.json";
import { apiResponseMessage } from "../../Resources/Languages/apiMessages";
import { IExcelFrequencyData, IKPIGraphResponse } from "../../types/graph";
import { IDirectReporteeUser } from "../../Store/Reducers/AuthModule/auth";
import { LanguageCode, UserDetail } from "../../types/user";
import {
  monthNameByNumbers,
  SelectedUserFieldNameEnum} from "../../Resources/Statics";
import { constants } from "../Constants";
import { MenuStructureType } from "../../types/cusomizedMenuTypes";
import { Person } from "../../types/person";
import { IKpiFrequencyData } from "../../types/kpi";

export type DueDateClasses =
  | "due-date-past"
  | "due-date-today"
  | "due-date-upcoming";


export function validateEmail() {
  const tld = '(?![0-9]+$)[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]';
  const emailRegx = new RegExp(
    `^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\\.)+${tld}$`,
    'i'
  );
  return emailRegx;
}

/**
 * Validates a text field for unwanted whitespace conditions.
 *
 * @param message - The error message to display when validation fails.
 * @param trimRequired - If true, ensures the text has no leading or trailing whitespace.
 * @param endWhiteSpaceCheck - If true, explicitly checks for whitespace only at the start or end of the text.
 *
 * @returns A validator function compatible with Ant Design Form rules.
 *
 * @example
 * rules={[
 *   {
 *     validator: validateTheTextWhitespace(
 *       convertText("whiteSpaceErrorMessage"),
 *       true
 *     ),
 *   },
 * ]}
 */
export const validateTheTextWhitespace =
  (
    message: string,
    trimRequired: boolean = true,
    endWhiteSpaceCheck: boolean = false
  ) =>
  (_: unknown, value: string) => {
    if (typeof value !== "string" || value === "") return Promise.resolve();

    const trimmedValue = value.trim();

    // Reject if field contains only whitespace
    if (trimmedValue === "") {
      return Promise.reject(new Error(message));
    }

    // Reject if trimRequired is true and there is leading/trailing whitespace
    // Check if text starts with whitespace
    if (trimRequired && /^\s/.test(value)) {
      return Promise.reject(new Error(message));
    }

    // Reject if only end whitespace validation is required
    if (endWhiteSpaceCheck && value !== trimmedValue) {
      return Promise.reject(new Error(message));
    }

    return Promise.resolve();
  };

export function validatePassword() {
  // Accept any non-alphanumeric character as the "special" character. The
  // narrower [!@#$%^&*] class rejected valid passwords using -, _, ., ? etc.
  const passwordRegx = new RegExp(
    /^(?=.*\d)(?=.*[^a-zA-Z\d\s])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
  );
  return passwordRegx;
}

export function divisionNameFormat(name: string) {
  if (name) {
    const arrayOfWords: string[] = name.split(" ");

    if (arrayOfWords.length > 2 && arrayOfWords[1].toLowerCase() === "of") {
      name = arrayOfWords.join(" ").replace(/\bof\b/gi, "of");
    }
    const key: string = arrayOfWords.join("_").toLowerCase();

    const regex = new RegExp(
      `\\b(${constants.REPORTEE_CAPITAL.join("|")})\\b`,
      "gi"
    );

    return name.replace(regex, (match) => match.toUpperCase());
  }
  return name;
}

export function formatCEOText(text: string): string {
  return text && text.trim().toLowerCase() === "ceo"
    ? text.toUpperCase()
    : text;
}

export function isValidURL(str: string) {
  try {
    /* eslint-disable no-new */
    new URL(str);
    return true; // If this succeeds, it's a valid URL
  } catch (e) {
    return false; // Otherwise, it's not a valid URL
  }
}

export function validateUrl() {
  // Accepts:
  //   - Optional https:// prefix (http:// is blocked — only https allowed)
  //   - www.DOMAIN.TLD (www requires a separate domain + TLD after it)
  //   - DOMAIN.TLD (without www)
  //   - Subdomains: stag-app.focuspower.co, sub.domain.co.uk
  //   - Path, query string, and fragment after TLD (e.g. ?a=1, #test)
  // Rejects:
  //   - http:// (insecure, only https allowed)
  //   - Ports (:8080, :3000 etc.)
  //   - Spaces anywhere in the URL
  //   - www.yesnoyesno (missing TLD — www needs domain.tld after it)
  //   - Non-https protocols: mailto:, ftp:, javascript:, file://
  //   - Bare hostnames with no TLD: localhost, yesnoyesno
  //   - Malformed: ..hi:hi:hi, -bad.com, example..com, example.com.
  // ICANN TLD Rules:
  //   - 2 or more characters long
  //   - Letters (a-z), numbers (0-9), hyphens (-)
  //   - Not wholly comprised of numbers
  //   - Not start or end with a hyphen
  const tld = '(?![0-9]+(?:[/?#]|$))[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]';
  const urlRegex = new RegExp(
    `^(https:\\/\\/)?(www\\.[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\\.${tld}|(?!www\\.)[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9-]+)*\\.${tld})([/?#][^\\s]*)?$`,
    'i'
  );
  return urlRegex;
}

export function validateName() {
  const nameRegx = new RegExp(/^[a-zA-ZäÄöÖüÜß\s'-]*$/);
  return nameRegx;
}

export function validateDecimalNumber() {
  const intgetNumberRegx = new RegExp(/^-?\d+(?:\.\d{1,2})?$/);
  return intgetNumberRegx;
}

export function validateIntegetNumber() {
  const intgetNumberRegx = new RegExp(/^\d+(\.\d+)?$/);
  return intgetNumberRegx;
}

export function validateFloatNumber() {
  const intgetNumberRegx = new RegExp(
    /^(-?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{1,2})?)$/
  );
  return intgetNumberRegx;
}

/**
 * Returns a regular expression for validating numbers in German format.
 *
 * The regular expression allows for the following German number formats:
 * - Whole numbers and decimals with a comma as the decimal separator.
 * - Thousands separators represented by dots.
 *
 * @returns {RegExp} Regular expression for validating German-formatted numbers.
 *
 * @example
 * const germanNumberValidator = validateGermanFloatNumber();
 * const isValid1 = germanNumberValidator.test('1.234.567,89');
 * console.log(isValid1);  // Output: true
 *
 * const isValid2 = germanNumberValidator.test('1234567.89');
 * console.log(isValid2);  // Output: false
 */
export function validateGermanFloatNumber() {
  const germanNumberRegex = new RegExp(
    /^(-?[0-9]{1,3}(?:\.?[0-9]{3})*(?:,[0-9]{1,2})?)$/
  );
  return germanNumberRegex;
}

export function validatePositiveNumber() {
  const intgetNumberRegx = new RegExp(/^[0-9]+(,[0-9]{3})*(.[0-9]{1,2})?$/);
  return intgetNumberRegx;
}

export function validatePositiveNumberGermanFormat() {
  const germanNumberRegex = new RegExp(/^[0-9]+(\.[0-9]{3})*(,[0-9]{1,2})?$/);
  return germanNumberRegex;
}

export function validateGermanNumber() {
  const germanNumberRegex = new RegExp(/^-?[0-9]+(\.[0-9]{3})*(,[0-9]{1,2})?$/);
  return germanNumberRegex;
}

export function setToLocalStorage(key: string, value: unknown) {
  localStorage.setItem(key, value as string);
}

// Function to clear specific keys from the browser's localStorage
export function clearLocalStorage(key: string | string[]) {
  if (typeof key === "string") {
    localStorage.removeItem(key);
  } else {
    key.forEach((string) => {
      localStorage.removeItem(string);
    });
  }
}

export function getToLocalStorage(itemName: string) {
  if (itemName === "language") {
    return localStorage.getItem(itemName);
  }
  return JSON.parse(localStorage.getItem(itemName) || "null");
}

export function getDirectLocalStorage(itemName: string) {
  if (localStorage.getItem(itemName)) return localStorage.getItem(itemName);
  return "";
}

export function errorHandling(error: any) {
  if (error?.name !== "CanceledError") {
    const customMessage =
      getToLocalStorage("language") === "De"
        ? textResource["500ErrorMsgDe"]
        : textResource["500ErrorMsgEn"];

    if (error.response) {
      return toast.error(apiResponseMessage(error.response.data, customMessage));
    }
    return toast.error(customMessage);
  }
  return null;
}

export function isScrolledToBottom(event: React.UIEvent<HTMLElement>): boolean {
  const target = event.target as any;
  return (
    Math.abs(
      target.scrollTop +
        target.offsetHeight -
        target.scrollHeight
    ) <= 1
  );
}

export const addThousandSeparator = (input: string | number) => {
  // Remove any existing thousand separators (e.g., commas)
  const sanitizedInput = input?.toString().replace(/[,]/g, "") || "";

  // Add thousand separators
  const formattedInput = sanitizedInput.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return formattedInput;
};

/**
 * Converts a number or string to German number format.
 *
 * This function takes a numeric or string input and converts it to a string
 * representing the number in German format. It uses the 'de-DE' locale for
 * formatting, with optional minimum and maximum fraction digits.
 *
 * @param {number | string} inputValue - The input value to be converted.
 * @param {number} minimumFractionDigits - The minimum number of fraction digits (default is 2).
 * @returns {string} The input value formatted in German number format.
 *
 * @example
 * const result1 = convertToGermanFormat(1234567.89);
 * console.log(result1); // Output: '1.234.567,89'
 *
 * const result2 = convertToGermanFormat('9876543.21', 1);
 * console.log(result2); // Output: '9.876.543,2'
 */
export const convertToGermanFormat = (
  inputValue: number | string,
  minimumFractionDigits = 2
) => {
  let givenValue = inputValue;
  if (typeof inputValue === "string") {
    if (inputValue === "") return "";
    givenValue = Number(inputValue);
  }

  const germanFormat = givenValue?.toLocaleString("de-DE", {
    minimumFractionDigits,
    maximumFractionDigits: 2});
  return germanFormat;
};

export const formatDate = (
  date: string,
  datefromat: string = "DD/MM/YYYY",
  convertToFormat: string = "DD/MM/YYYY"
) => {
  return moment(date, datefromat).format(convertToFormat);
};

export const formatNumber = (
  numberInput: number | string,
  convertToFormat = "en-US"
) => {
  return (
    typeof numberInput === "string" ? Number(numberInput) : numberInput
  )?.toLocaleString(convertToFormat);
};

export const dateFormat =
  getToLocalStorage("language") === "De" ? "DD.MM.YYYY" : "MM/DD/YYYY";

export const isDeadlineValid = (
  startTime: any,
  deadLine: any,
  isDeadlineSelected: boolean
) => {
  // This below condition checks that if deadline is selcted then it should be greater than starttime if starttime is provided
  if (
    isDeadlineSelected &&
    deadLine &&
    startTime &&
    (startTime.isAfter(deadLine, "day") || startTime.isSame(deadLine, "day"))
  ) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject("Deadline must be greater then Start Time");
  }
  return Promise.resolve();
};

/**
 * Disables dates that are older than one year from the current date.
 *
 * @param current - The date to check, typically provided by Ant Design's DatePicker.
 * @returns True if the date should be disabled, false otherwise.
 */
export const disabledDateBeforeOneYear = (current: dayjs.Dayjs) => {
  return (
    current &&
    current.isBefore(dayjs().subtract(1, "year").add(1, "day").startOf("day"))
  );
};

/**
 * Disables dates that are in the past (before today).
 *
 * @param current - The date to check.
 * @returns True if the date is before today, false otherwise.
 */
export const disabledPastDate = (current: dayjs.Dayjs) => {
  return current && current.isBefore(dayjs().startOf("day"));
};

/**
 * Disables meeting dates before today or more than one year ahead. The
 * meetings list offers years up to next year, so a later meeting would be
 * saved but never shown; the API rejects it too.
 *
 * @param current - The date to check.
 * @returns True if the date is outside today .. one year from today.
 */
export const disabledMeetingDate = (current: dayjs.Dayjs) => {
  return (
    disabledPastDate(current) ||
    (current && current.isAfter(dayjs().add(1, "year").endOf("day")))
  );
};

/**
 * Disables dates that are older than two years from today, while keeping
 * dates within the last two years and all future dates selectable.
 *
 * Used for objective date pickers per the acceptance criteria:
 * - Selectable: today, future dates, and dates up to 2 years in the past.
 * - Disabled: dates more than 2 years before today.
 *
 * @param current - The date to check, typically provided by Ant Design's DatePicker.
 * @returns True if the date should be disabled, false otherwise.
 */
export const disabledDateBeforeTwoYears = (current: dayjs.Dayjs) => {
  return (
    current &&
    current.isBefore(dayjs().subtract(2, "year").startOf("day"))
  );
};

export const allowedFileExtensions = [
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
  ".xls",
  ".xlsx",
  ".gdoc",
  ".gsheet",
  ".gslides",
  ".pdf",
  ".txt",
  ".zip",
  ".rar",
  ".csv",
  ".tsv",
  ".jpg",
  ".jpeg",
  ".png",
];

export const maxDocSizeInMB = 5;
export const maxImageSizeInMB = 2;

export const validateFileType = (
  { name }: UploadFile,
  extentions: string[]
) => {
  if (!extentions) {
    return true;
  }

  const isAllowedExtension = extentions.some((ext) =>
    name.toLowerCase().endsWith(ext)
  );
  return isAllowedExtension;
};

export const validateFileSize = ({ size }: UploadFile, maxSize: number) => {
  const fileSizeInMB = (size as number) / (1024 * 1024);

  return maxSize > fileSizeInMB;
};

export const graphDateFormat = "YYYY-MM-DD[T]HH:mm:ss.ss";

const currentYear = new Date().getFullYear();

export const generateTabsFromList = (list: (string | number)[]) => {
  const tabs = list?.map((item) => {
    return {
      key: item?.toString(),
      label: item?.toString(),
      children: null};
  });

  return tabs;
};

export const generateYearTabsForReview = (yearsToPast: number) => {
  const years = [];

  for (let year = currentYear; year >= yearsToPast; year--) {
    years.push(year);
  }

  const yearTabs = generateTabsFromList(years);

  return yearTabs;
};

/**
 * Generates a list of year options for use in a Select dropdown.
 *
 * @param yearsToPast passed year
 * @returns An array of objects with `label` and `value` properties for each year.
 *
 * Example:
 *   generateYearForReviewOptions(2020)
 *   -> [ { label: 2025, value: 2025 }, { label: 2024, value: 2024 }, ... { label: 2020, value: 2020 } ]
 */

export const generateYearForReviewOptions = (
  yearsToPast: number
): { label: number; value: number }[] => {
  const years: { label: number; value: number }[] = [];
  if (currentYear >= yearsToPast)
    for (let year = currentYear; year >= yearsToPast; year--) {
      years.push({ label: year, value: year });
    }

  return years;
};

export const getCurrentMonth = () => {
  return new Date().getMonth() + 1;
};

export const getWeekNumber = (d: Date = new Date()) => {
  const formatedDate: Date = new Date(
    Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())
  );
  formatedDate.setUTCDate(
    formatedDate.getUTCDate() + 4 - (formatedDate.getUTCDay() || 7)
  );
  const yearStart: Date = new Date(
    Date.UTC(formatedDate.getUTCFullYear(), 0, 1)
  );
  const weekNo = Math.ceil(
    ((formatedDate.getTime() - yearStart.getTime()) / 86400000 + 1) / 7
  );
  return weekNo;
};

export const toggleSelectedPerson = (
  selectedPersonsFilter: string[],
  value: string
) => {
  const updatedSelectedPersons = [...selectedPersonsFilter];
  const index = updatedSelectedPersons.indexOf(value);

  if (index === -1) {
    updatedSelectedPersons.push(value);
  } else {
    updatedSelectedPersons.splice(index, 1);
  }

  return updatedSelectedPersons;
};

export const createDate = (year: string, month: string) => {
  return `${year}-${month.padStart(2, "0")}-01`;
};

export const escapeRegExp = (text: string) => {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

/**
 * Checks if two arrays of strings are equal.
 * Arrays are considered equal if they have the same elements, regardless of order.
 *
 * @param {string[]} _arr1 - The first array to compare.
 * @param {string[]} _arr2 - The second array to compare.
 * @returns {boolean} True if the arrays are equal, false otherwise.
 */
export function isArrayEqual(_arr1: string[], _arr2: string[]) {
  if (
    !Array.isArray(_arr1) ||
    !Array.isArray(_arr2) ||
    _arr1.length !== _arr2.length
  ) {
    return false;
  }

  // .concat() to not mutate arguments
  const arr1 = _arr1.concat().sort();
  const arr2 = _arr2.concat().sort();

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

/**
 * Checks whether the given frequency unit (daily, weekly, or monthly)
 * falls within the current time frame based on the provided data.
 *
 * @param frequencyData - The frequency data object containing year, week, month, or date
 * @param kpiFrequency - The frequency type: "string"
 * @returns true if the unit is in the current time period, false otherwise
 */
export function isUnitInCurrentTime(
  frequencyData: any,
  kpiFrequency: string
): boolean {
  const cYear = moment().format("YYYY");

  // Check for weekly frequency match
  if (kpiFrequency === "weekly" && frequencyData?.year.toString() === cYear) {
    const currentWeek = getWeekNumber();
    return frequencyData?.week === currentWeek;
  }

  // Check for daily frequency match
  if (kpiFrequency === "daily") {
    const currentDate = moment().format("DD.MM.YYYY");
    return frequencyData?.date === currentDate;
  }

  // Check for monthly frequency match (default case)
  if (kpiFrequency === "monthly" && frequencyData?.year.toString() === cYear) {
    const currentMonth = getCurrentMonth();
    return frequencyData?.month === currentMonth;
  }

  // If no match, return false
  return false;
}

export const isValidLanguage = (language: string) => {
  return ["en", "de"]?.includes(language?.toLocaleLowerCase());
};

export * from "./planning";
export * from "./feedback";
export * from "./excel";
export * from "./tableUtils";

/**
 * Builds a query string with the provided query parameters.
 *
 * @param {Record<string, any>} params - The query parameters.
 * @returns {string} - The built query string.
 */
export const buildQueryStringWithQueryParams = <T extends Record<string, any>>(
  params: T
): string => {
  const encodedParams = Object.entries(params)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join("&");

  return encodedParams;
};

/**
 * Calculates the remaining time until a specified due date and returns a formatted string representation.
 *
 * @param dueDate - The date string in the format specified by the `format` parameter, representing the due date and time.
 *                  Defaults to an empty string. If an invalid or empty string is provided, the result will be "0d 0h".
 * @param format - The format of the `dueDate` parameter. Must be compatible with the Moment.js library's parsing format.
 *
 * @returns A formatted string representing the remaining time, with years (y), months (m), days (d), and hours (h).
 *          If the due date is in the past or an invalid date string is provided, the result will be "0d 0h".
 *
 * @example
 * ```typescript
 * const dueDate = "2024-03-15T18:30:00.000Z";
 * const format = "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]";
 * const remainingTime = getTimeRemainingValue(dueDate, format);
 * console.log(remainingTime); // Output: "0d 7h" (assuming the current date is "2024-03-15T11:30:00.000Z")
 * ```
 */
export const getTimeRemainingValue = (dueDate: string = "", format: string) => {
  let formattedRemainingTime = "";
  let remainingTimeDueDate = dueDate;
  if (remainingTimeDueDate !== "" || !!remainingTimeDueDate) {
    if (moment(remainingTimeDueDate, format).isValid()) {
      remainingTimeDueDate = moment(dueDate, format).format(
        "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
      );
    }
    const n = moment.utc();
    const endOfDay = moment.utc(remainingTimeDueDate).endOf("day");
    const dy = moment.duration(endOfDay.diff(n));

    const years = dy.years();
    const month = dy.months();
    const days = dy.days();
    const hours = dy.hours();
    const minutes = dy.minutes();

    if (years !== 0) {
      formattedRemainingTime = `${years}y ${month}m ${days}d`;
    } else if (month !== 0) {
      formattedRemainingTime = `${month}m ${days}d`;
    } else if (days === 0) {
      formattedRemainingTime = minutes < 30 ? `${hours}h` : `${hours + 1}h`;
    } else {
      formattedRemainingTime =
        minutes < 30 ? `${days}d ${hours}h` : `${days}d ${hours + 1}h`;
    }
  } else {
    formattedRemainingTime = "0d 0h";
  }
  return formattedRemainingTime;
};

/**
 * Converts a given string to capitalCase format.
 *
 * @param {string} str - The string to be converted.
 * @returns {string} The capitalCase formatted string.
 */
export const convertToCapitalCase = (str: string) => {
  if (str)
    return str.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  return str;
};

/**
 * Rounds up numbers in the graph data to ensure consistent formatting.
 * If the graph data contains objects with a "type" property, it rounds up the "value" property of those objects.
 * If the graph data contains objects with both "target" and "actual" properties, it rounds up both properties.
 * @param graphData - An array of objects representing graph data.
 * @returns A new array of graph data with numbers rounded up to two decimal places.
 */
export const roundUpNumbersInGraphData = (
  graphData: IKPIGraphResponse["data"]
) => {
  return graphData.map((data: any) => {
    if (data.hasOwnProperty("type")) {
      return { ...data, value: parseFloat(data?.value.toFixed(2)) };
    }
    if (data.hasOwnProperty("target") && data.hasOwnProperty("actual")) {
      return {
        ...data,
        target: parseFloat(data?.target.toFixed(2)),
        actual: parseFloat(data?.actual.toFixed(2))};
    }
    return { ...data };
  });
};

/**
 * Generates KPI frequency data suitable for Excel export from the provided graph data.
 *
 * @param graphData The graph data containing KPI information.
 * @returns An array of KPI frequency data formatted for Excel export.
 */
export const generateKPIFrequencyDataForExcel = (
  graphData: IKPIGraphResponse["data"]
) => {
  const result = graphData.reduce<
    Record<
      string,
      {
        name: string;
        year: string;
        actual: number;
        target: number;
      }
    >
  >((acc, item: any) => {
    const customKey = item.name;

    // Create object if not exist
    if (!acc[customKey]) {
      acc[customKey] = {
        name: item.name,
        year: item.year ? String(item.year) : "",
        actual: 0,
        target: 0};
    }

    // Update object value
    if (item.hasOwnProperty("type") && item?.type === "actual") {
      acc[customKey].actual = item?.value;
    }

    if (item.hasOwnProperty("type") && item?.type === "target") {
      acc[customKey].target = item?.value;
    }

    return acc;
  }, {});

  return Object.values(result);
  /* FP-2050 Remove the code once QA approve this code */
  /*
  return graphData.map((data: any) => {
    if (data.hasOwnProperty("type")) {
      return {
        name: data?.name,
        year: data?.year,
        actual:
          data?.type === "actual" ? parseFloat(data?.value.toFixed(2)) : 0,
        target:
          data?.type === "target" ? parseFloat(data?.value.toFixed(2)) : 0};
    }
    if (data.hasOwnProperty("target") && data.hasOwnProperty("actual")) {
      return {
        name: data?.name,
        year: data?.year,
        actual: parseFloat(data?.actual.toFixed(2)),
        target: parseFloat(data?.target.toFixed(2))};
    }
    return { ...data };
  });
  */
};

/**
 * Extracts the sorted column name from the sorter object or array of sorter objects.
 *
 * @param sorter The sorter object or array of sorter objects provided by Ant Design.
 * @returns The name of the sorted column with a prefix of '-' for descending order, or an empty string if no sorting is applied.
 */
export const getSortedColumn = (
  sorter: any
): string => {
  if (!sorter) return "";

  const sort = Array.isArray(sorter) ? sorter[0] : sorter;

  if (!sort?.field || !sort?.order) return "";

  const columnName =
    sort.order === "descend" ? `-${String(sort.field)}` : String(sort.field);

  // 🔁 Toggle priority specifically
  if (columnName === "priority") return "-priority";
  if (columnName === "-priority") return "priority";

  return columnName;
};

/**
 * Retrieves the selected field value from either the reporteeUser or userDetail based on conditions.
 * If the reporteeUser's ID matches the userDetail's ID and the userDetail is a success manager,
 * it returns the specified field value from the userDetail's CEO details; otherwise, it returns
 * the specified field value from the reporteeUser.
 *
 * @param field - The field name to retrieve from either the reporteeUser or userDetail.
 * @param reporteeUser - The IDirectReporteeUser object representing the reportee user.
 * @param userDetail - The UserDetail object representing the user's details.
 * @returns The value of the specified field from either the reporteeUser or userDetail.
 */
export const getSelectedPerson = (
  field: SelectedUserFieldNameEnum,
  reporteeUser: IDirectReporteeUser,
  userDetail: UserDetail
) => {
  return reporteeUser?.id === userDetail?.id && userDetail?.is_success_manager
    ? userDetail?.ceo_details?.[field]
    : reporteeUser?.[field];
};

export const getYears = (back: number) => {
  const allYears = new Date().getFullYear();
  return Array.from({ length: back }, (v, i) => ({
    value: allYears - back + i + 1,
    label: allYears - back + i + 1})).reverse();
};

/**
 * Recursively sets all non-object properties of a nested object to empty values.
 *
 * - String values are set to an empty string (`""`).
 * - Number values are set to `0`.
 * - Other non-object values default to an empty string (`""`).
 * - Nested objects are processed recursively.
 *
 * @template T - A generic type extending `NestedObject`, ensuring the function works with deeply nested structures.
 * @param {T} obj - The input object whose non-object properties need to be reset.
 * @returns {T} - A new object with the same structure but with all non-object values reset.
 */
type NestedObject = Record<string, any>;

export const setObjectKeysEmpty = <T extends NestedObject>(obj: T): T => {
  const result = {} as T;
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (typeof value === "object") {
        setObjectKeysEmpty(value);
      } else if (typeof value === "string") {
        result[key] = "" as T[typeof key]; // Set non-object values to an empty string
      } else if (typeof value === "number") {
        result[key] = 0 as T[typeof key]; // Set non-object values to an empty string
      } else {
        result[key] = "" as T[typeof key]; // Set non-object values to an empty string
      }
    }
  }

  return result;
};

export const checkQuarterIsPassed = (
  year: number,
  quarter: number
): boolean => {
  const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based (0 = January)

  const currentQuarter = Math.ceil(currentMonth / 3); // 1: Jan-Mar, 2: Apr-Jun, 3: Jul-Sep, 4: Oct-Dec

  if (year < currentYear) {
    return true; // The year is in the past, so the quarter has definitely passed.
  }
  if (year === currentYear) {
    return quarter <= currentQuarter; // Check if the quarter is before the current quarter.
  }
  return false; // The year is in the future, so the quarter hasn't passed.
};

/**
 * Returns a fixed number with the specified number of decimal places.
 *
 * @param number - The number to be fixed.
 * @param fixed - The number of decimal places to round the number to.
 * @returns The fixed number with the specified number of decimal places.
 */
export const fixedNumber = (number: number, fixed: number): number => {
  return Number(number.toFixed(fixed));
};

/**
 * Checks whether the provided URL is a Google Spreadsheet link.
 * @param url - The URL to check.
 * @returns True if the URL is a Google Spreadsheet, false otherwise.
 */
export const isGoogleSpreadsheetUrl = (url: string): boolean => {
  const target = "https://docs.google.com/spreadsheets/";
  return url.startsWith(target);
};

export const formatMonthNameValue = (
  monthNumber: number,
  year: number
): string => {
  return `${monthNameByNumbers[monthNumber]}-${year}`;
};

/**
 * Check if the provided date is in the past, today, or upcoming.
 * @param date - The date to check (string, Date, or Dayjs object)
 * @returns "past" | "today" | "upcoming"
 */
export function checkDateClass(
  date: string | Date | dayjs.Dayjs
): DueDateClasses {
  const inputDate = dayjs(date).startOf("day");
  const today = dayjs().startOf("day");

  if (inputDate.isBefore(today)) return "due-date-past";
  if (inputDate.isSame(today)) return "due-date-today";

  return "due-date-upcoming";
}

export function buildMenuTree(data: MenuStructureType[]): MenuStructureType[] {
  const map = new Map<
    string,
    MenuStructureType & { _children?: MenuStructureType[] }
  >();
  const roots: MenuStructureType[] = [];

  // Step 1: Add all items to a map with optional _children
  data.forEach((item) => {
    map.set(item.id, { ...item, _children: [] });
  });

  // Step 2: Assign children to their parent
  data.forEach((item) => {
    const currentItem = map.get(item.id)!;
    if (item.parent_id) {
      const parent = map.get(item.parent_id);
      if (parent) {
        parent._children!.push(currentItem);
        parent._children!.sort((a, b) => a.order - b.order);
      }
    } else {
      roots.push(currentItem);
    }
  });

  // Step 3: Remove _children if empty, rename to children if not
  const cleanItem = (
    item: MenuStructureType & { _children?: MenuStructureType[] }
  ): MenuStructureType => {
    const { _children, ...rest } = item;
    if (_children && _children.length > 0) {
      return {
        ...rest,
        children: _children.map(cleanItem)};
    }
    return rest;
  };

  return roots.sort((a, b) => a.order - b.order).map(cleanItem);
}

// utils/colorUtils.ts
export const getContrastColor = (bgColor: string): string => {
  // Remove # if present
  const color = bgColor.replace("#", "");

  // Convert to RGB
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  // Calculate brightness (YIQ formula)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // Return black or white depending on brightness
  return brightness > 128 ? "#000000" : "#FFFFFF";
};

/**
 * Checks whether a given date falls within the current calendar year.
 *
 * @param date - The date to check. Can be a `Date` object or a date string
 *               parseable by `dayjs`. If the input is invalid or undefined, returns `false`.
 * @returns `true` if the given date is in the current year, otherwise `false`.
 *
 * @example
 * isCurrentYear("2025-03-15"); // true (if the current year is 2025)
 * isCurrentYear(new Date("2023-12-31")); // false
 */

export function isCurrentYear(date: string | Date | null | undefined): boolean {
  if (!date) return false;

  const parsedDate = dayjs(date);
  if (!parsedDate.isValid()) return false;

  return parsedDate.year() === dayjs().year();
}

/**
 * Checks whether a given date falls within the current calendar year.
 *
 * @param date - The date to check. Can be a `Date` object or a date string
 *               parseable by `dayjs`. If the input is invalid or undefined, returns `false`.
 * @returns `true` if the given date is in the current year, otherwise `false`.
 *
 * @example
 * isBothYearSame("2025-03-15", "2025-03-15"); // true (if the current year is 2025)
 * isBothYearSame("2025-03-15", "2023-12-31"); // false
 */

export function isBothYearSame(
  startdate: string | Date | null | undefined,
  endDate: string | Date | null | undefined,
  startDateformat: string = "DD.MM.YYYY",
  endDateformat: string = "DD-MM-YYYY"
): boolean {
  if (!startdate || !endDate) return false;

  const parsedStartDate = dayjs(startdate, startDateformat);
  const parsedEndDate = dayjs(endDate, endDateformat);

  if (!parsedStartDate.isValid() || !parsedEndDate.isValid()) return false;

  return parsedStartDate.year() === parsedEndDate.year();
}

/**
 * Prevents the propagation of the "Backspace" key event on an input element.
 *
 * This is typically used to stop the "Backspace" key from triggering a parent
 * component's behavior (e.g., clearing a selected item in a tag/multiselect input).
 *
 * @param e - The keyboard event triggered on the input element.
 */
export const handlePreventInputKeyDownAction = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  if (e.key === "Backspace") {
    // Prevent clearing selected item
    e.stopPropagation();
  }
};
// utils/withChangeGuard.ts
/**
 * Wraps an onChange handler to prevent double-select
 * and debounce rapid repeated changes.
 *
 * @param handler The original onChange handler
 * @param delay Debounce delay in ms (default 500)
 */
/**
 * Wraps an onChange handler to prevent double-select
 * and debounce rapid repeated changes.
 *
 * @param handler The original onChange handler
 * @param delay Debounce delay in ms (default 500)
 */
export function withChangeGuard<T = any>(
  handler: (value: T, option: any) => void,
  delay = 500
) {
  let lastChange = 0;

  return (value: T, option: any) => {
    const now = Date.now();

    if (now - lastChange < delay) {
      // Ignore second/rapid clicks silently
      return;
    }

    lastChange = now;
    handler(value, option);
  };
}


/**
 * Extracts the filename from a given URL string.
 * This function assumes the filename is the last segment of the URL path
 * after the last '/' character, and includes any file extension.
 *
 * @param {string} url The URL string from which to extract the filename.
 * @returns {string} The extracted filename, or an empty string if no '/' is found.
 */
export function getFilenameFromUrl(url: string): string {
  const lastSlashIndex = url.lastIndexOf("/");
  if (lastSlashIndex === -1) {
    // No slash found, the entire URL might be the filename or an invalid URL
    return "";
  }
  return url.slice(lastSlashIndex + 1);
}

/*
 * Capitalizes the first letter of a given string.
 *
 * @param {string} str - The input string to capitalize.
 * @returns {string} The string with its first letter capitalized.
 */
export function capitalizeFirstLetter(str: string) {
  // Check if the string is empty or null
  if (!str) {
    return "";
  }
  // Capitalize the first character and concatenate with the rest of the string
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Returns a CSS class name based on the provided status value.
 *
 * This function checks the given status against a predefined mapping.
 * If the status exists in the map, it returns the corresponding class name.
 * Otherwise, it returns the default class name.
 *
 * @param status - The selected status value
 * @returns The CSS class name associated with the status
 */
export const getProcessStatusClassName = (
  status: string = "default"
): string => {
  const statusClassMap: Record<string, string> = {
    "it supported": "low",
    aligned: "medium process-aligned",
    "not defined": "high",
    implemented: "process-implemented",
    default: "processStatus"};

  return statusClassMap[status.toLocaleLowerCase()] || statusClassMap.default;
};

/**
 * Determines the correct responsible person ID based on the selected person
 * and the current user's role.
 *
 * Logic:
 * - If user details are not available, return the provided responsiblePerson.
 * - If the selected responsiblePerson is different from the current user,
 *   return it directly.
 * - If the selected person is the current user:
 *   - Return the CEO's ID if the user is a CEO.
 *   - Otherwise, return the current user's ID.
 *
 * @param responsiblePerson - Selected responsible person ID
 * @param userDetails - Current user details including role and CEO info
 * @returns The resolved responsible person ID
 */
export const getResponsiblePersonId = (
  responsiblePerson: string,
  userDetails?: UserDetail
): string => {
  if (!userDetails) return responsiblePerson;

  const { id, ceo_details: ceoDetails } = userDetails;
  const isCEO = isUserCeo(userDetails);
  const ceoId = ceoDetails?.id ?? responsiblePerson;

  if (responsiblePerson !== id) {
    return responsiblePerson;
  }

  return isCEO ? ceoId : id;
};

/**
 * Validates a selected year.
 * - If the selected year (string) represents the current year or a future year,
 *   it returns the selected year as a number.
 * - If the selected year represents a past year or is invalid,
 *   it returns the current year.
 *
 * @param selectedYear - The year chosen by the user as a string
 * @returns A valid year (current year or later) as a number
 */
export function getCurrentOrFutureYear(selectedYear: string): string {
  const year = Number(selectedYear);

  // Handle invalid or non-numeric year values
  if (Number.isNaN(year)) {
    return currentYear.toString();
  }

  if (year < currentYear) {
    return currentYear.toString();
  }

  return year.toString();
}

/**
 * Checks whether the currently logged-in user is able to archive or delete a KPI.
 *
 * This function retrieves the `user` object from local storage and safely determines
 * if the user has the necessary permissions to perform these actions.
 *
 * @returns {boolean} `true` if the user is able to archive or delete a KPI, otherwise `false`.
 *
 * @example
 * if (isUserAbleToArchiveOrDeleteKPI()) {
 *   // User has permission to archive or delete KPI
 * }
 */
export function isUserAbleToArchiveOrDeleteKPI(): boolean {
  const userData = getToLocalStorage("user");
  if (!userData || typeof userData !== "object") return false;
  if (isUserCeo(userData) || userData.user_level.c_level) {
    return true;
  }
  return false;
}

/**
 * Removes duplicate objects from an array based on a specified key.
 *
 * This function uses the `reduce` method to iterate over the array and
 * accumulates unique objects into a new array. It checks for duplicates
 * using the provided key extractor function.
 *
 * @param arr - The array of objects to process.
 * @param getKey - A function that extracts a unique key from each object.
 * @returns A new array containing only unique objects based on the key.
 *
 * @example
 * const data = [
 *   { id: 1, name: 'Alice' },
 *   { id: 2, name: 'Bob' },
 *   { id: 1, name: 'Alice' },
 * ];
 * const uniqueData = removeDuplicatesById(data, (item) => item.id);
 * console.log(uniqueData);
 * // Output: [{ id: 1, name: 'Alice' }, { id: 2, name: 'Bob' }]
 */
export const removeDuplicatesById = <T>(
  arr: T[],
  getKey: (item: T) => string | number
): T[] => {
  return arr.reduce<T[]>((acc, item) => {
    if (!acc.some((x) => getKey(x) === getKey(item))) {
      acc.push(item);
    }
    return acc;
  }, []);
};

/**
 * Normalizes a user-entered URL to ensure it has a valid protocol.
 *
 * Handles all common input formats:
 * - Already valid (https://..., http://...) → returned as-is
 * - Protocol-relative (//...) → https: prepended
 * - Starts with www or bare domain (www.example.com, example.com) → https:// prepended
 *
 * @param url - The raw URL string entered by the user.
 * @returns A fully qualified URL string safe to use as an href or to store.
 *
 * @example
 * normalizeUrl("example.com")       // "https://example.com"
 * normalizeUrl("www.web.de")        // "https://www.web.de"
 * normalizeUrl("http://example.com") // "http://example.com"
 * normalizeUrl("https://example.com") // "https://example.com"
 */
export const normalizeUrl = (url: string): string => {
  if (!url || !url.trim()) return "";
  const trimmed = url.trim();
  // Already has a recognised protocol — return untouched
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  // Protocol-relative URL — add https:
  if (trimmed.startsWith("//")) return `https:${trimmed}`;
  // Everything else (www.example.com, example.com, etc.) — prepend https://
  return `https://${trimmed}`;
};

/**
 * Checks if a URL starts with "www" (case-insensitive).
 *
 * @param url - The URL to check.
 * @returns `string` with "//" prefix if the URL starts with "www", otherwise the original `string`.
 *
 * @example
 * const url = "www.example.com";
 * const result = checkUrlStartWithWWW(url);
 * console.log(result); // Output: "//www.example.com"
 */

export const checkUrlStartWithWWW = (url: string): string => {
  return normalizeUrl(url);
};

/**
 * Resolves the language an auth page reached from an e-mail link (invitation
 * sign-up, password reset) renders in and returns it as the dropdown code.
 *
 * Those links carry `?language=<code>` chosen by the backend (the company
 * default for invitations, the user's preference for resets). localStorage
 * "language" is what every consumer actually reads: useLanguage.convertText,
 * the axios language header, errorHandling and the antd locale. A param that
 * is only kept in component state therefore left the header dropdown saying
 * "En" over German content whenever the previous user on this browser had
 * stored "De". A valid param is written through to storage here, before the
 * first render reads it, so the dropdown and the copy agree. Without a valid
 * param, storage (then the German default) applies and nothing is written, so
 * a later login can still seed the language from the profile.
 */
export const applyLanguageFromUrl = (
  languageParam: string | null
): LanguageCode => {
  if (languageParam && isValidLanguage(languageParam)) {
    const code = languageParam.toLowerCase() as LanguageCode;
    setToLocalStorage("language", capitalizeFirstLetter(code));
    return code;
  }
  const stored = getToLocalStorage("language");
  return (
    stored && isValidLanguage(stored) ? stored.toLowerCase() : "de"
  ) as LanguageCode;
};

/**
 * Removes `?language=` from the current URL in place (no navigation), so a
 * reload does not re-apply the mailed seed over a language the visitor chose.
 */
export const dropLanguageParamFromUrl = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("language")) return;
  url.searchParams.delete("language");
  window.history.replaceState(window.history.state, "", url.toString());
};

/**
 * Changes the application language and persists it in localStorage.
 * Optionally manages loading state and handles fallback in case of error.
 *
 * @param langValue - Selected language code (e.g., "en", "de").
 * @param setLang - State setter function to update language in the app.
 * @param setIsLoading - Optional state setter to control loading UI.
 *
 * @returns Promise<void>
 */
export const changeLanguage = async (
  langValue: string,
  setLang: (lang: LanguageCode) => void,
  setIsLoading?: (value: boolean) => void
): Promise<void> => {
  // Return early if no language is provided
  if (!langValue) return;

  // Captured before the write so a failure rolls back to what was actually on
  // screen. This used to write the OPPOSITE of what was requested, which moved
  // the user to a language they never chose whenever storage threw (some
  // private-browsing modes do). Same defect the header dropdown had.
  const previousLang = getToLocalStorage("language");

  try {
    // Enable loading state if provided
    setIsLoading?.(true);

    // Update language state
    setLang(langValue as LanguageCode);

    // Save selected language in localStorage
    setToLocalStorage("language", capitalizeFirstLetter(langValue));

    // An auth page reached from an e-mail link carries `?language=` (see
    // applyLanguageFromUrl). It only seeds the first paint; an explicit pick
    // must survive the reload below, so drop it before reloading.
    dropLanguageParamFromUrl();

    // Reload the page to apply language changes globally
    window.location.reload();
  } catch (error) {
    // Roll back to the previously selected language, if there was one.
    if (previousLang) {
      setLang(previousLang.toLowerCase() as LanguageCode);
      setToLocalStorage("language", capitalizeFirstLetter(previousLang));
    }

    // Handle error using global error handler
    errorHandling(error);
  } finally {
    // Disable loading state
    setIsLoading?.(false);
  }
};

/**
 * Checks if the current user is the content owner.
 *
 * @param user - The user object.
 * @returns `true` if the user is the content owner, `false` otherwise.
 */
export function isContentOwner(user: {
  id: string;
  user_id?: string;
}): boolean {
  const userData = getToLocalStorage("user");
  const id = user?.user_id || user?.id;

  if (
    (userData.is_success_manager &&
      String(userData.ceo_details.id) === String(id)) ||
    String(userData.id) === String(id)
  ) {
    return true;
  }
  return false;
}

/**
 * Returns the name of the logged-in user.
 *
 * @returns `true` if the user is the content owner, `false` otherwise.
 */
export function getTheLoggedInUserName(): string {
  const userData = getToLocalStorage("user");
  if (userData.is_success_manager || userData.is_shareholder)
    return `${userData.ceo_details.first_name} ${userData.ceo_details.last_name}`;

  return `${userData.first_name} ${userData.last_name}`;
}

/**
 * Checks if the given URL points to an image file.
 * @param url - The URL to check.
 * @returns `true` if the URL points to an image file, `false` otherwise.
 */
export const isImageFile = (url: string): boolean => {
  if (!url) return false;
  return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(url);
};

/**
 * Checks if the given URL points to a PDF file.
 * @param url - The URL to check.
 * @returns `true` if the URL points to a PDF file, `false` otherwise.
 */
export const isPdfFile = (url: string): boolean => {
  if (!url) return false;
  return url?.toLowerCase().endsWith(".pdf");
};

// utils/fileIcon.tsx

export const getFileIcon = (fileName: string): ReactNode => {
  if (!fileName) return React.createElement(FileUnknownOutlined);
  const ext = fileName.split(".").pop()?.toLowerCase();

  switch (ext) {
    case "pdf":
      return React.createElement(FilePdfOutlined, {
        style: { color: "#ff4d4f" }});

    case "xls":
    case "xlsx":
    case "csv":
      return React.createElement(FileExcelOutlined, {
        style: { color: "#52c41a" }});

    case "doc":
    case "docx":
      return React.createElement(FileWordOutlined, {
        style: { color: "#1890ff" }});

    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "webp":
      return React.createElement(FileImageOutlined, {
        style: { color: "#faad14" }});

    case "txt":
      return React.createElement(FileTextOutlined);

    case "zip":
    case "rar":
      return React.createElement(FileZipOutlined);

    default:
      return React.createElement(FileUnknownOutlined);
  }
};

export const getTheProgressClass = (process: number): string => {
  if (!process) return "red";

  if (process < 60) {
    return "red";
  }
  if (process === 100) {
    return "green";
  }
  return "yellow";
};

export const getObjectiveTypeClass = (type: string): string => {
  if (!type) return "";

  switch (type) {
    case "Division":
      return "warning-tag";
    case "Company":
      return "success-tag";
    default:
      return "";
  }
};

/**
 * Checks if the given URL is a web URL and adds "//" prefix if it doesn't have one.
 * @param url - The URL to check.
 * @returns `string` with "//" prefix if the URL is a web URL, otherwise the original `string`.
 */
export const checkWebUrl = (url: string): string => {
  if (!url) return "";
  const trimmed = url.trim();
  const lowerUrl = trimmed.toLowerCase();
  if (
    lowerUrl.startsWith("http://") ||
    lowerUrl.startsWith("https://") ||
    lowerUrl.startsWith("//") ||
    lowerUrl.startsWith("/") ||
    lowerUrl.startsWith("#")
  ) {
    return trimmed;
  }
  return `//${trimmed}`;
};

/**
 * Disables dates that are older than Five year from the current date.
 *
 * @param current - The date to check, typically provided by Ant Design's DatePicker.
 * @returns True if the date should be disabled, false otherwise.
 */
export const disabledDateBeforeFiveYears = (current: dayjs.Dayjs) => {
  return (
    current &&
    current.isBefore(dayjs().subtract(5, "year").add(1, "day").startOf("day"))
  );
};
